module.exports = __webpack_public_path__ + "img/kachel-03.459b680c.jpg";